<template>
  <div>
    <el-form :model="form" label-width="100px" v-loading="loading" style="max-width:640px">
      <el-form-item label="公司 Logo">
        <div class="logo-row">
          <img v-if="form.logoUrl" class="logo-preview" :src="form.logoUrl" alt="" />
          <img v-else class="logo-preview" src="/brand-logo.png" title="平台默认" alt="华锐智企云 ERP" />
          <div class="logo-actions">
          <el-upload
            action="#"
            :http-request="elUploadHttpRequest"
            :show-file-list="false"
            :before-upload="beforeLogoUpload"
            :on-success="onLogoUpload"
            accept="image/*"
          >
              <el-button size="small" type="primary" plain :loading="logoUploading">上传 Logo</el-button>
            </el-upload>
            <el-button
              v-if="form.logoUrl"
              size="small"
              type="text"
              style="color:#f56c6c"
              @click="clearLogo"
            >清除</el-button>
            <div class="hint">建议正方形图片，小于 2MB；未上传时侧栏显示平台默认 Logo</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="公司名称" required>
        <el-input v-model="form.companyName" placeholder="请输入公司名称" />
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="form.contactName" />
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="form.contactPhone" />
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="form.address" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" />
      </el-form-item>

      <div class="section-title">发票信息</div>
      <p class="section-tip">用于套餐订阅申请开票时自动带出，可随时修改。开票仅支持 1% 增值税普通发票。</p>
      <el-form-item label="发票抬头">
        <el-input v-model="form.invoiceTitle" placeholder="与营业执照名称一致" />
      </el-form-item>
      <el-form-item label="纳税人识别号">
        <el-input v-model="form.invoiceTaxNo" placeholder="统一社会信用代码" />
      </el-form-item>
      <el-form-item label="开票地址">
        <el-input v-model="form.invoiceAddress" placeholder="选填" />
      </el-form-item>
      <el-form-item label="开票电话">
        <el-input v-model="form.invoicePhone" placeholder="选填" />
      </el-form-item>
      <el-form-item label="开户银行">
        <el-input v-model="form.invoiceBankName" placeholder="选填" />
      </el-form-item>
      <el-form-item label="银行账号">
        <el-input v-model="form.invoiceBankAccount" placeholder="选填" />
      </el-form-item>
      <el-form-item label="收票邮箱">
        <el-input v-model="form.invoiceEmail" placeholder="接收电子发票邮箱，选填" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-check" :loading="saving" @click="save">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCompany, saveCompany } from '../../api/sys'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'SysCompany',
  data() {
    return {
      loading: false,
      saving: false,
      logoUploading: false,
      form: {
        id: null,
        companyName: '',
        contactName: '',
        contactPhone: '',
        address: '',
        logoUrl: '',
        remark: '',
        invoiceTitle: '',
        invoiceTaxNo: '',
        invoiceAddress: '',
        invoicePhone: '',
        invoiceBankName: '',
        invoiceBankAccount: '',
        invoiceEmail: ''
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    async load() {
      this.loading = true
      try {
        const res = await getCompany()
        const data = res.data || {}
        this.form = {
          id: data.id || null,
          companyName: data.companyName || '',
          contactName: data.contactName || '',
          contactPhone: data.contactPhone || '',
          address: data.address || '',
          logoUrl: data.logoUrl || '',
          remark: data.remark || '',
          invoiceTitle: data.invoiceTitle || '',
          invoiceTaxNo: data.invoiceTaxNo || '',
          invoiceAddress: data.invoiceAddress || '',
          invoicePhone: data.invoicePhone || '',
          invoiceBankName: data.invoiceBankName || '',
          invoiceBankAccount: data.invoiceBankAccount || '',
          invoiceEmail: data.invoiceEmail || ''
        }
      } finally {
        this.loading = false
      }
    },
    beforeLogoUpload(file) {
      const ok = file && file.type && file.type.indexOf('image/') === 0
      if (!ok) {
        this.$message.warning('请上传图片文件')
        return false
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('Logo 请小于 2MB')
        return false
      }
      this.logoUploading = true
      return true
    },
    onLogoUpload(res) {
      this.logoUploading = false
      const data = (res && res.data) || {}
      if (res && res.code && res.code !== 200) {
        this.$message.error(res.message || '上传失败')
        return
      }
      const url = data.url || ''
      if (!url) {
        this.$message.error('上传失败')
        return
      }
      this.form.logoUrl = url
      this.$message.success('Logo 已上传，请保存')
    },
    clearLogo() {
      this.form.logoUrl = ''
    },
    async save() {
      if (!this.form.companyName) return this.$message.warning('请填写公司名称')
      this.saving = true
      try {
        const res = await saveCompany(this.form)
        const data = (res && res.data) || this.form
        this.$store.commit('patchUser', {
          tenantName: data.companyName || this.form.companyName,
          companyLogoUrl: data.logoUrl || this.form.logoUrl || ''
        })
        this.$message.success('已保存')
        this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.logo-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.logo-preview {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  object-fit: contain;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}
.logo-fallback {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: linear-gradient(135deg, #2563eb, #0ea5e9);
  color: #fff;
  font-weight: 700;
  font-size: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.logo-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.hint {
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
}
.section-title {
  font-weight: 600;
  color: #0f172a;
  margin: 8px 0 6px 100px;
  max-width: 540px;
}
.section-tip {
  margin: 0 0 14px 100px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
  max-width: 540px;
}
</style>
